import React from "react"
import PropTypes from 'prop-types'
import { Card, CardHeader, CardBody, Row, Col, Button, FormGroup, Input, Label } from "reactstrap"
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import ClipLoader from "react-spinners/ClipLoader"
import { withToastManager } from 'react-toast-notifications'
import { withTranslation } from 'react-i18next'
import DraggableModal from '../../components/modal/DraggableModal'
import moment from 'moment'
// Redux
import { connect } from 'react-redux'
import { getAllergens, deleteAllergen, searchAllergens, copySelectedAllergens, copyAllAllergens } from '../../redux/actions/allergenActions'
import { getCompaniesForUser } from '../../redux/actions/companyActions'
import { getFoods } from '../../redux/actions/dishActions';
// Util
import { hasRole } from "util/hasRole"
import store from "redux/store"
import { Typeahead } from "react-bootstrap-typeahead"
import { SET_COPY_ALLERGEN_LOADING } from "redux/types"
import AppIcon from 'components/icons/AppIcon';

class Allergens extends React.Component {

    emptyAllergen = {
        name: '',
        description: '',
        foods: []
    }

    constructor(props) {
        super(props);
        this.state = {
            allergen: null,
            isDescriptionModalOpen: false,
            allergenToDelete: this.emptyAllergen,
            deleteAllergenModal: false,
            isLoading: true,
            allergenSearch: '',
            company: null,
            alergenIds: [],
        };
        this.toastManager = props.toastManager;
    }

    async componentDidMount() {
        this.props.getAllergens(0, 10);
        this.props.getFoods();
        hasRole("ROLE_SUPER_ADMIN") && this.props.getCompaniesForUser()
        this.setState({ isLoading: false });
    }

    handleChange = (id) => {
        let { alergenIds } = this.state
        if (!alergenIds.includes(id)) {
            alergenIds.push(id)
        } else {
            alergenIds.splice(alergenIds.indexOf(id), 1);
        }
        this.setState({ alergenIds: alergenIds })
    }

    onChangePage = (page, size) => {
        if (this.state.allergenSearch !== "") {
            this.props.searchAllergens(page - 1, this.props.allergenData.size, this.state.allergenSearch);
        } else {
            this.props.getAllergens(page - 1, this.props.allergenData.size);
        }
    }

    onChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        if (this.state.allergenSearch !== "") {
            this.props.searchAllergens(currentPage - 1, currentRowsPerPage, this.state.allergenSearch);
        } else {
            this.props.getAllergens(currentPage - 1, currentRowsPerPage);
        }
    }

    openDeleteDialog = (row) => {
        this.setState({ deleteAllergenModal: !this.state.deleteAllergenModal, allergenToDelete: row });
    }

    openDescriptionDialog = (row) => {
        this.setState({ isDescriptionModalOpen: true, allergen: row, });
    }

    closeDialog = () => {
        this.setState({ deleteAllergenModal: false });
    }

    closeDescriptionModalBtn = () => {
        this.setState({ isDescriptionModalOpen: !this.state.isDescriptionModalOpen });
    }

    deleteAllergen = () => {
        this.props.deleteAllergen(this.toastManager, this.state.allergenToDelete.id)
        this.setState({ deleteAllergenModal: false });
    }

    handleAllergenSearch = (event) => {
        this.setState({ allergenSearch: event.target.value });
    }

    copyDialog = (copyAllDialog) => {
        if (copyAllDialog === false) {
            store.dispatch({ type: SET_COPY_ALLERGEN_LOADING, payload: { copyAllDialog: true, copyDialog: true } })
        }
        else if (copyAllDialog === undefined) {
            store.dispatch({
                type: SET_COPY_ALLERGEN_LOADING, payload: { copyAllDialog: false, copyDialog: true }
            })
        }
    }

    closeCopyDialog = () => {
        store.dispatch({
            type: SET_COPY_ALLERGEN_LOADING,
            payload: {
                copyDialog: false
            }
        })
        this.setState({ company: null })
    }

    handleChangeCompany = (companyEntry) => {
        let company = { ...this.state.company };
        if (companyEntry.length > 0) {
            company = companyEntry[0];
        } else { company = null; }
        this.setState({ company: company })
    }

    copyData = () => {
        const { alergenIds, company } = this.state
        const requestData = {
            ids: alergenIds,
            companyId: company.id
        }
        this.props.copySelectedAllergens(requestData, this.toastManager)
    }

    render() {
        const { allergens, totalElements, copyAllDialog, copyDialog, copyLoading } = this.props.allergenData
        const { companiesForUser } = this.props.companyData
        const { allergen, isDescriptionModalOpen, isLoading, allergenToDelete, deleteAllergenModal, company, alergenIds } = this.state
        const { t } = this.props

        const deleteModal = <DraggableModal
            isOpen={deleteAllergenModal}
            toggle={this.closeDialog}
            size={"sm"}
            title={<strong>{t("delete_allergen")}</strong>}
            body={<div>
                {t("delete_allergen_message")}<strong>{allergenToDelete.name}</strong>{"?"}
            </div>
            }
            footer={
                <Button color="success" onClick={this.deleteAllergen}>{t("delete")}</Button>
            }
            modalStyle={{ maxWidth: '600px' }}
        />

        const descriptionModal = <DraggableModal
            isOpen={isDescriptionModalOpen}
            toggle={this.closeDescriptionModalBtn}
            size={"sm"}
            title={<strong>{t("allergen_description")}</strong>}
            body={<Row>
                <Col md={12}>
                    <FormGroup>
                        <Input
                            disabled
                            name="description"
                            type="textarea"
                            rows="4"
                            value={allergen && allergen.description}
                        />
                    </FormGroup>
                </Col>
            </Row>}
        />

        const copyToOtherCompany = <DraggableModal
            isOpen={copyDialog}
            toggle={this.closeCopyDialog}
            size={"sm"}
            title={<strong>{t("copy_to_another_company")}</strong>}
            body={<div>
                <FormGroup>
                    <Typeahead
                        selected={company === null ? [] : companiesForUser.filter(c => c.name === company.name)}
                        id="company"
                        clearButton
                        labelKey="name"
                        onChange={this.handleChangeCompany}
                        options={companiesForUser}
                        placeholder={t("select_company")}
                        paginationText={t("display_additional")}
                        emptyLabel={t("no_matches_found")}
                    />
                </FormGroup>
            </div>}
            footer={
                <Button style={{ width: '82.64px', height: '40px' }} color="success" disabled={company === null} onClick={copyAllDialog ? () => this.props.copyAllAllergens(company.id, this.toastManager) : () => this.copyData()}>{copyLoading ? <ClipLoader
                    size={20}
                    color={"#e14eca"}
                    loading={copyLoading}
                /> : t("copy")}</Button>
            }
            footerStyle={{ justifyContent: 'flex-end' }}
        />

        const allergenColumns = [
            {
                name: t("name"),
                selector: "name",
                sortable: true,
                width: hasRole("ROLE_SUPER_ADMIN") ? "18%" : "20%"
            },
            {
                name: t("description"),
                selector: "description",
                width: hasRole("ROLE_SUPER_ADMIN") ? "9%" : "10%",
                center: true,
                cell: row => <span>
                    <Button className="btn-icon btn-round" color="warning" onClick={() => this.openDescriptionDialog(row)}><AppIcon name="info" size="lg" /></Button>
                </span>
            },
            {
                name: t("foods"),
                selector: "foods",
                width: hasRole("ROLE_SUPER_ADMIN") ? "33%" : "40%",
                center: true,
                cell: row => <span>
                    {row.foods.map(data => {
                        return data.name
                    }).join(", ")}
                </span>
            }
        ]

        const createdBy = {
            name: t("created_by"),
            selector: "createdBy",
            sortable: true,
            width: "9%",
            cell: row => <span>
                {row.createdBy ? `${row.createdBy.firstName} ${row.createdBy.lastName !== null ? row.createdBy.lastName : ""}` : ''}
            </span>
        }

        const createdAt = {
            name: t("created_at"),
            selector: "createdAt",
            sortable: true,
            width: "9%",
            cell: row => moment.unix(row.createdAt).format('DD.MM.YYYY.')
        }

        const updatedAt = {
            name: t("updated_at"),
            selector: "updatedAt",
            sortable: true,
            width: "9%",
            cell: row => moment.unix(row.updatedAt).format('DD.MM.YYYY.')
        }

        const actions = {
            name: t("actions"),
            center: true,
            width: "8%",
            cell: row => <span>
                <Button className="btn-icon btn-round" color="success" tag={Link} to={"/admin/allergen/" + row.id}><AppIcon name="edit" size="lg" /></Button>
                <Button className="btn-icon btn-round" color="danger" onClick={() => this.openDeleteDialog(row)}><AppIcon name="delete" size="lg" /></Button>
            </span>
        }

        const copy = {
            name: t("copy"),
            width: "5%",
            center: true,
            cell: row =>
                <FormGroup check>
                    <Label check>
                        <Input type="checkbox" name="select" id="select" onChange={() => this.handleChange(row.id)} style={{ position: 'relative' }} checked={alergenIds.some(item => item === row.id)} />
                        <span className="form-check-sign">
                            <span className="check" />
                        </span>
                    </Label>
                </FormGroup>
        }

        if (hasRole("ROLE_SUPER_ADMIN")) {
            allergenColumns.push(createdBy)
            allergenColumns.push(createdAt)
            allergenColumns.push(updatedAt)
            allergenColumns.push(actions)
            allergenColumns.push(copy)
        } else {
            allergenColumns.push(createdAt)
            allergenColumns.push(updatedAt)
            allergenColumns.push(actions)
        }

        return (
            <div className="content content-diet">
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardHeader className={'control-header'}>
                                <Row>
                                    <Col sm={12} md={4}>
                                    </Col>
                                    <Col sm={7} md={3}>
                                        <Input style={{ cursor: 'pointer' }} type="text" placeholder={t("search_allergens")} autoComplete="off" name="allergenSearch" id="allergenSearch" value={this.state.allergenSearch || ''} onChange={this.handleAllergenSearch}
                                            onKeyPress={(event) => {
                                                if (event.key === "Enter") {
                                                    this.state.allergenSearch === "" ? this.props.getAllergens(0, 10) : this.props.searchAllergens(0, this.props.allergenData.size, this.state.allergenSearch)
                                                }
                                            }} />
                                    </Col>
                                    <Col xs={1} sm={1}>
                                        <Button color="success" size="sm" type="button" onClick={this.state.allergenSearch === "" ? () => this.props.getAllergens(0, 10) : () => this.props.searchAllergens(0, this.props.allergenData.size, this.state.allergenSearch)}><i className="fas fa-search"></i></Button>
                                    </Col>
                                    <Col sm={5} md={4} style={{ textAlign: 'right' }}>
                                        <Button tag={Link} to="/admin/allergen" color="success">{t("create_allergen")}</Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {isLoading ? (
                                    <div style={{ textAlign: 'center' }}>
                                        <ClipLoader
                                            size={60}
                                            color={"#e14eca"}
                                            loading={isLoading}
                                        />
                                    </div>
                                ) : (
                                    <DataTable
                                        columns={allergenColumns}
                                        data={allergens}
                                        noHeader={true}
                                        highlightOnHover
                                        pagination
                                        paginationServer
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                        paginationTotalRows={totalElements}
                                        paginationComponentOptions={{ rowsPerPageText: t("rows_per_page") }}
                                        noDataComponent={t("no_records")}
                                        onChangePage={(page, totalRows) => this.onChangePage(page, totalRows)}
                                        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => this.onChangeRowsPerPage(currentRowsPerPage, currentPage)}
                                    />
                                )}
                            </CardBody>
                            {deleteModal}
                            {descriptionModal}
                            {copyToOtherCompany}
                        </Card>
                        <div>
                            {hasRole("ROLE_SUPER_ADMIN") && <Button color="success" size="sm" type="button" disabled={alergenIds.length === 0} onClick={() => this.copyDialog()}><AppIcon name="copy" size="sm" className="me-1" /> {t("copy_selected_to_another_company")}</Button>}
                            {hasRole("ROLE_SUPER_ADMIN") && <Button color="success" size="sm" type="button" disabled={allergens && allergens.length === 0} onClick={() => this.copyDialog(copyAllDialog)}><AppIcon name="copy" size="sm" className="me-1" /> {t("copy_all_to_another_company")}</Button>}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

Allergens.propTypes = {
    allergenData: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    allergenData: state.allergenData,
    companyData: state.companyData
})

const mapActionsToProps = { getAllergens, deleteAllergen, searchAllergens, getFoods, getCompaniesForUser, copySelectedAllergens, copyAllAllergens }

export default connect(mapStateToProps, mapActionsToProps)(withToastManager(withTranslation()(Allergens)));